import { MutationTree } from 'vuex';
import { MailSettingState, MailSetting, Authentications } from './types';
import * as types from './mutation-types';
import { ErrorDetail } from '../../types';

const resetAllErrors = (state: MailSettingState): void => {
    const showState = state.show;
    showState.error = false;
    showState.errorCode = undefined;
    showState.errorMsg = undefined;

    const updateState = state.update;
    updateState.error = false;
    updateState.errorTitle = undefined;
    updateState.errorDetails = undefined;
    updateState.category = undefined;

    const connectionState = state.connection;
    connectionState.error = false;
    connectionState.errorTitle = undefined;
    connectionState.errorDetails = undefined;
};

export const mutations: MutationTree<MailSettingState> = {
    // 設定取得系
    [types.SHOW_START](state) {
        resetAllErrors(state);
        const showState = state.show;
        showState.error = false;
        showState.errorCode = undefined;
        showState.errorMsg = undefined;
        showState.isProcessing = true;
        showState.isFetchSuccess = false;
    },

    [types.SHOW_SUCCESS](
        state,
        payload: {
            authentications: Array<Authentications>;
            mailSetting: MailSetting;
        }
    ) {
        state.authentications = payload.authentications;
        state.mailSetting = payload.mailSetting;

        const showState = state.show;
        showState.isProcessing = false;
        showState.isFetchSuccess = true;
    },

    [types.SHOW_FAILURE](state, payload: { code: string; message: string }) {
        const showState = state.show;
        showState.errorCode = payload.code;
        showState.errorMsg = payload.message;
        showState.error = true;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;
    },

    // 設定更新系
    [types.UPDATE_START](state, category) {
        const updateState = state.update;
        updateState.error = false;
        updateState.errorTitle = undefined;
        updateState.errorDetails = undefined;
        updateState.isProcessing = true;
        updateState.category = category;
    },

    [types.UPDATE_SUCCESS](state) {
        const updateState = state.update;
        updateState.isProcessing = false;
        updateState.category = undefined;
    },

    [types.UPDATE_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const updateState = state.update;
        updateState.errorTitle = payload.errorTitle;
        updateState.errorDetails = payload.errorDetails;
        updateState.error = true;
        updateState.isProcessing = false;
    },

    // 接続テスト系
    [types.CONNECTION_START](state) {
        resetAllErrors(state);
        const connectionState = state.connection;
        connectionState.isProcessing = true;
    },

    [types.CONNECTION_SUCCESS](state) {
        const connectionState = state.connection;
        connectionState.isProcessing = false;
    },

    [types.CONNECTION_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const connectionState = state.connection;
        connectionState.errorTitle = payload.errorTitle;
        connectionState.errorDetails = payload.errorDetails;
        connectionState.error = true;
        connectionState.isProcessing = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const showState = state.show;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;

        const updateState = state.update;
        updateState.isProcessing = false;

        const connectionState = state.connection;
        connectionState.isProcessing = false;
    },

    [types.CLEAR_ALL](state) {
        resetAllErrors(state);
        state.mailSetting = undefined;
        state.authentications = undefined;
    },
};
